import React, { useState, useEffect } from 'react';
import axios from 'axios';

const BlogDeleter = () => {
  const [blogs, setBlogs] = useState([]);
  const [selectedBlogId, setSelectedBlogId] = useState('');
  const [notification, setNotification] = useState(null);

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const serverBaseUrl = process.env.REACT_APP_SERVER_BASE_URL || 'http://localhost:5000';
        const res = await axios.get(`${serverBaseUrl}/api/blogs`);
        setBlogs(res.data);
      } catch (error) {
        console.error('Помилка завантаження блогів:', error);
      }
    };
    fetchBlogs();
  }, []);

  const handleDelete = async () => {
    if (!selectedBlogId) {
      setNotification('Будь ласка, виберіть блог для видалення');
      setTimeout(() => setNotification(null), 3000);
      return;
    }

    try {
      const serverBaseUrl = process.env.REACT_APP_SERVER_BASE_URL || 'http://localhost:5000';
      await axios.delete(`${serverBaseUrl}/api/blogs/${selectedBlogId}`);
      setNotification(`Блог та картка з ID ${selectedBlogId} успішно видалені`);
      setTimeout(() => setNotification(null), 3000);

      setBlogs(blogs.filter((blog) => blog._id !== selectedBlogId));
      setSelectedBlogId('');
    } catch (error) {
      console.error('Помилка видалення блогу:', error);
      setNotification('Помилка при видаленні блогу');
      setTimeout(() => setNotification(null), 3000);
    }
  };

  return (
    <div className="blog-deleter">
      <h2>Видалити блог</h2>
      <div className="form-group">
        <label>Виберіть блог:</label>
        <select
          value={selectedBlogId}
          onChange={(e) => setSelectedBlogId(e.target.value)}
          required
        >
          <option value="">-- Виберіть блог --</option>
          {blogs.map((blog) => (
            <option key={blog._id} value={blog._id}>
              {blog.title}
            </option>
          ))}
        </select>
      </div>
      <button onClick={handleDelete}>Видалити</button>
      {notification && <div className="notification">{notification}</div>}
    </div>
  );
};

export default BlogDeleter;